// Firebase is accessed via REST API (no SDK) to maintain CRA 4 / webpack 4 compatibility.
// Auth endpoint: https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=API_KEY
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
